import styles from './Divider.module.scss';

type Props = {
  label: string;
  color?: string;
  marginTop?: number;
  marginBottom?: number;
};

export default function Divider(props: Props) {
  const { label, color, marginTop, marginBottom } = props;
  
  const style = {
    ...(color ? { color, fontWeight: 600 } : {}),
    ...(marginTop !== undefined ? { marginTop: `${marginTop}px` } : {}),
    ...(marginBottom !== undefined ? { marginBottom: `${marginBottom}px` } : {})
  };
  
  return (
    <div className={styles.divider} style={style}>
      {label}
    </div>
  );
};
